import "../style/style.less";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import * as Sentry from "@sentry/react";
import { SnackbarProvider } from "notistack";
import React, { Suspense } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import theme from "../theme/theme";
import { lazyWithRetry as lazy } from "../lib/react";

import AppRoutes from "./routes";

const ModalsContainer = lazy(
  () =>
    import(
      "./modals/ModalsContainer"
      /* webpackChunkName: "components/modalsContainer" */
      /* webpackPrefetch: true */
    )
);

const Notifier = lazy(
  () =>
    import(
      "./utils/notifier"
      /* webpackChunkName: "components/notifier" */
      /* webpackPrefetch: true */
    )
);

const muiCache = createCache({
  key: "mui",
  prepend: true,
});

// Organization of Routes
function App() {
  return (
    <Suspense fallback={null}>
      <CacheProvider value={muiCache}>
        <MuiThemeProvider theme={theme}>
          <SnackbarProvider autoHideDuration={3000}>
            <DndProvider backend={HTML5Backend}>
              <Notifier />
              <AppRoutes />
              <ModalsContainer />
            </DndProvider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </CacheProvider>
    </Suspense>
  );
}

export default Sentry.withProfiler(App);
